<template>
  <article class="card">
    <figure>
      <img :src="imageURL">
      <img class="overlay" src="@/assets/whiteCardWave.svg">
    </figure>
    <div class="text">
      <h1>{{ title }}</h1>
      <p v-html="textHTML">
      </p>
    </div>
  </article>
</template>

<script>

import { documentToHtmlString } from "@contentful/rich-text-html-renderer";

export default {
  name: "IntroCard",
  props: {
    title: String,
    text: Object,
    imageURL: Array,
  },
  data() {
    return {
      textHTML: "",
    };
  },
  created() {
    this.textHTML = documentToHtmlString(this.text);
  },
  beforeUpdate(){
    this.textHTML = documentToHtmlString(this.text);
  },
};
</script>

<style lang="scss">
article.card {
  width: 380px;
  background-color: white;
  border-radius: 30px;
  overflow: hidden;
  box-shadow: 0 6px 6px rgba(0,0,0,0.15);
  figure {
    margin: 0;
    position: relative;
    img {
      width: 100%;
    }
    img.overlay {
      position: absolute;
      bottom: 0; left: 0;
    }
  }
  .text {
    padding:15px 30px 30px 30px;
    h1 {
      position: static;
      width: 100%;
      font-size: 30px;
      margin-top: 0;
    }
    p {
      font-weight: normal;
      font-size: 18px;
      line-height: 29px;
      letter-spacing: 0.15px;
      color: #4D4D4D;
    }
  }
}
@media screen and (max-width: 500px) {
  article.card {
    width: 80vw;
    .text {
      padding:8px 15px 15px 15px;
      h1 {
        position: static;
        width: 100%;
        font-size: 24px;
        margin-top: 0;
      }
      p {
        font-weight: normal;
        font-size: 1em;
        line-height: 1.5em;
        letter-spacing: 0.15px;
        color: #4D4D4D;
      }
    }
  }
}
</style>
